import React, { useState } from "react";
import { useSelector } from "react-redux";
import { redirect, useLoaderData } from "react-router-dom";
import { motion } from "framer-motion";

import Sidebar from "../Demo/Sidebar";
import Item from "./Item";
import { getArchiveData } from "./data";
import { Pagination } from "./Pagination";
import { MobileMenu } from "../Common/MobileMenu";
import GridViewIcon from "../icons/grid-view-icon";
import ItemGrid from "./ItemGrid";
import SearchBox from "../search/search-box/SearchBox";
import SearchResults from "../search/search-results";
import ListViewIcon from "../icons/list-view-icon";
import { ToastContainer } from "react-toastify";

export async function loader({ request }) {
  const url = new URL(request.url);
  const page = url.searchParams.get("page");
  const pageNumber = Number(page) ? Number(page) : 1;
  try {
    const archive = await getArchiveData(pageNumber);
    return { archive };
  } catch (error) {

    if (error.response?.status === 404) {
      return {
        archive: {
          count: 0,
          results: [],
        }
      };
    }

    if (error.response?.status === 403) {
      return redirect("/login");
    }
    throw error;
  }
}

const Archive = () => {
  const [changeView, setChangeView] = useState(false);
  const { archive } = useLoaderData();  
  const { results, ...pagination } = archive;
  const pageCount = Math.ceil(pagination.count / 10);
  const searchResultsState = useSelector((state) => state.search.active);


  const variant = {
    hidden: {
      opacity: 0,
      scale: 0.95,
    },
    visible: {
      transition: {
        duration: 0.2,
        ease: "easeOut",
      },
      opacity: 1,
      scale: 1,
    },
  };

  return (
    <div id='archive' dir='rtl'>
      <div className='with-sidebar'>
        <div className='mobile-menu-wrapper'>
          <MobileMenu />
        </div>
        <Sidebar />
        <div className='main'>
          <h1>آرشیو من</h1>
          <div className='change-view'>
            <SearchBox />
            <div className='views-container'>
              {!searchResultsState &&
                (changeView ? (
                  <GridViewIcon
                    width={24}
                    height={18}
                    className='cursor-pointer'
                    setChangeView={setChangeView}
                    changeView={changeView}
                  />
                ) : (
                  <ListViewIcon
                    width={29}
                    height={18}
                    className='cursor-pointer'
                    setChangeView={setChangeView}
                    changeView={changeView}
                  />
                ))}
            </div>
          </div>
          {!searchResultsState ? (
            results.length ? (
              <>
                <div className='table-wrapper'>
                  <div className='table'>
                    {!changeView && (
                      <div className='thead'>
                        <div className='thc'></div>
                        <div className='thc'>نام فایل</div>
                        <div className='thc'>تاریخ بارگذاری</div>
                        <div className='thc'>نوع فایل</div>
                        <div className='thc'>مدت زمان</div>
                        <div className='thc'></div>
                      </div>
                    )}
                    <div className='tbody'>
                      {changeView ? (
                        <motion.div
                          variants={variant}
                          initial='hidden'
                          animate='visible'
                          className='list-new'
                        >
                          {results.map((data) => {
                            return <ItemGrid key={data.id} itemData={data} />;
                          })}
                        </motion.div>
                      ) : (
                        results.map((data) => (
                          <Item key={data.id} data={data} />
                        ))
                      )}
                    </div>
                  </div>
                </div>
                {pageCount > 1 && (
                  <Pagination pagination={pagination} pageCount={pageCount} />
                )}
              </>
            ) : (
              <div>آرشیو شما خالی است.</div>
            )
          ) : (
            <SearchResults />
          )}
        </div>
      </div>
      <ToastContainer />
    </div>
  );
};

export default Archive;
